import { type Contact, type LeaseContact, ContactType } from '@rentguru/commons-utils';
import isNil from 'lodash/isNil';

export interface LeaseContactsByRole {
  contacts: LeaseContact[];
  tenants: Contact[];
  guarantors: Contact[];
  lessors: Contact[];
}

export const splitLeaseContactsByRole = (
  leaseContacts: LeaseContact[],
  contactsById: Map<string, Contact>
): LeaseContactsByRole =>
  leaseContacts.reduce<LeaseContactsByRole>(
    (acc, leaseContact) => {
      const contact = contactsById.get(leaseContact.contactId);
      acc.contacts.push({ ...leaseContact, contact });
      if (isNil(contact)) {
        return acc;
      }
      switch (leaseContact.contactRole) {
        case ContactType.TENANT:
          acc.tenants.push(contact);
          return acc;
        case ContactType.GUARANTOR:
          acc.guarantors.push(contact);
          return acc;
        case ContactType.OWNER:
        case ContactType.MEMBER:
          acc.lessors.push(contact);
          return acc;
        default:
          return acc;
      }
    },
    { contacts: [], tenants: [], guarantors: [], lessors: [] }
  );
